"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipPortal = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const use_dom_root_1 = require("../hooks/use-dom-root");
const use_onclick_outside_1 = __importDefault(require("../hooks/use-onclick-outside"));
const use_transition_state_1 = __importDefault(require("../hooks/use-transition-state"));
const poper_1 = require("../poper");
const tooltip_styles_1 = require("../tooltip.styles");
const tooltip_types_1 = require("../tooltip.types");
const utils_1 = require("../utils");
const Launchpad = ({ root, children }) => {
    return root ? (0, react_dom_1.createPortal)(children, root) : children;
};
const TooltipPortal = ({ to = { current: new Set() }, container = { current: null }, trigger = tooltip_types_1.TriggerDirection.STATIC, direction = tooltip_types_1.TooltipDirection.UP, placement = tooltip_types_1.PlacementDirection.BODY, arrow: showArrow = true, closingTimeout = 220, styles, tooltipLabel, tooltipText, }) => {
    var _a;
    const [visible, setVisible] = (0, react_1.useState)(false);
    const root = (0, use_dom_root_1.useDOMRoot)({
        anchor: 'tooltip-launchpad',
        style: 'root theme-container',
    });
    const $tooltip = (0, react_1.useRef)(null);
    const popper = (0, react_1.useRef)(null);
    const [state, close] = (0, use_transition_state_1.default)(visible, {
        duration: closingTimeout,
    });
    const event = (0, react_1.useRef)();
    const show = (0, react_1.useCallback)((evt) => __awaiter(void 0, void 0, void 0, function* () {
        evt.preventDefault();
        if (visible)
            return;
        event.current = evt;
        setVisible(true);
    }), [visible]);
    const hide = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (visible && state === 'show') {
            yield close();
        }
        setVisible(false);
    }), [visible, state, close]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (!to.current || state !== 'appear' || !event.current)
            return;
        const ref = ((trigger === 'click' || trigger === 'static') &&
            Array.from(to.current).find((el) => { var _a; return el.contains((_a = event.current) === null || _a === void 0 ? void 0 : _a.target); })) ||
            event.current.target;
        popper.current && ((_a = popper.current) === null || _a === void 0 ? void 0 : _a.destroy());
        popper.current = (0, poper_1.createPopper)(ref, $tooltip.current, {
            placement: utils_1.directionAlias[direction],
            modifiers: [
                ...(showArrow ? [poper_1.arrow] : []),
                poper_1.offset,
                (0, poper_1.overflow)(container.current || document.body),
                (0, poper_1.adaptiveDirection)(container.current, direction),
            ],
        });
    }, [state, to, direction, trigger, container, showArrow]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (state !== 'idle')
            return;
        (_a = popper.current) === null || _a === void 0 ? void 0 : _a.setOptions({ modifiers: [...poper_1.silent] });
    }, [state]);
    (0, use_onclick_outside_1.default)((0, utils_1.toClickOutside)(popper), hide, trigger === 'click');
    (0, react_1.useEffect)(() => {
        const controls = to.current;
        if (!controls || controls.size === 0)
            return;
        if (trigger === 'static') {
            controls.forEach(($item) => {
                show({ target: $item });
            });
            return;
        }
        const handlerType = trigger === 'click' ? 'click' : 'mouseover';
        controls.forEach(($item) => {
            $item.addEventListener(handlerType, show);
            trigger === 'hover' && $item.addEventListener('mouseleave', hide);
            trigger === 'click' && $item.addEventListener('touchstart', show);
        });
        return () => {
            controls.forEach(($item) => {
                $item.removeEventListener(handlerType, show);
                $item.removeEventListener('mouseleave', hide);
                trigger === 'click' && $item.removeEventListener('touchstart', show);
            });
        };
    }, [trigger, (_a = to.current) === null || _a === void 0 ? void 0 : _a.size]);
    if (/init|idle/.test(state))
        return null;
    const tooltiptData = (react_1.default.createElement(tooltip_styles_1.StyledTooltipContent, null,
        tooltipLabel && react_1.default.createElement(tooltip_styles_1.StyledTooltipLabel, null, tooltipLabel),
        tooltipText && react_1.default.createElement(tooltip_styles_1.StyledTooltipText, null, tooltipText)));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(tooltip_styles_1.StyledRoot, { className: "root" }),
        react_1.default.createElement(Launchpad, { root: placement === 'body' ? root : null },
            react_1.default.createElement(tooltip_styles_1.StyledTooltip, { ref: $tooltip, visible: state === 'show', placement: placement === 'local', style: styles !== null && styles !== void 0 ? styles : {}, "data-popper-reference-hidden": true },
                tooltiptData,
                showArrow && react_1.default.createElement(tooltip_styles_1.StyledArrow, { direction: direction, "data-popper-arrow": true })))));
};
exports.TooltipPortal = TooltipPortal;
